import axios from 'axios';
import { useStore } from 'vuex';

export const isFinancePermission = async (to, from, next) => {
    const store = useStore()
    const token = localStorage.getItem('token')
    if (!token) {
        return next({ name: 'login' })
    }
    try {
        const { data: userFromApi } = await axios.get('auth/token', { headers: { token } })
        await store.dispatch('saveUser', userFromApi)
        if (userFromApi.role !== 'Admin' ) {
            await store.dispatch('saveBusiness', userFromApi.business[0]);
        }
        const user = store.state.user

        if (!user || !user.role) { return next({ name: 'login' }) }

        next()
    } catch (error) {
        localStorage.removeItem('token')
        next({ name: 'login' })
    }
}

export const isProyectaPermission = async (to, from, next) => {
    const store = useStore()
    const token = localStorage.getItem('token')
    if (!token) {
        return next({ name: 'login' })
    }
    try {
        const { data: userFromApi } = await axios.get('auth/token', { headers: { token } })
        await store.dispatch('saveUser', userFromApi)
         if (userFromApi.role !== 'Admin' ) {
            await store.dispatch('saveBusiness', userFromApi.business[0]);
        }
        const user = store.state.user

        if (!user || !user.role) { return next({ name: 'login' }) }

        next()
    } catch (error) {
        localStorage.removeItem('token')
        next({ name: 'login' })
    }
}

